<script setup lang="ts">
/**
 * App Layout Component — Donor Portal
 *
 * Main application layout with sidebar and header
 */
import { RouterView } from 'vue-router';
import AppHeader from './AppHeader.vue';
import AppSidebar from './AppSidebar.vue';
import AppFooter from './AppFooter.vue';
import BreadcrumbsComponent from '@/shared/components/navigation/BreadcrumbsComponent.vue';

const route = useRoute();
</script>

<template>
  <div>
    <AppHeader />

    <div class="lg:pl-0">
      <AppSidebar />
    </div>

    <div class="lg:pl-[60px] h-screen flex flex-col">
      <main class="mt-4 flex-1 overflow-hidden">
        <div class="h-full flex flex-col px-4 sm:px-6 lg:px-4 pb-14">
          <!-- Breadcrumbs -->
          <div
            v-if="route.path !== '/'"
            class="p-4 shrink-0"
          >
            <BreadcrumbsComponent />
          </div>

          <!-- Page content -->
          <div class="flex-1 min-h-0 overflow-y-auto scrollbar-hide pb-12">
            <RouterView />
          </div>
        </div>
      </main>
    </div>

    <AppFooter />
  </div>
</template>
